import React, { useMemo } from 'react';
import { useTranslation } from 'utils/i18n';
import LegalLayout from 'components/legal/LegalLayout';
import { mapGdprToSections } from 'utils/legal/sections';

const GDPR = () => {
  const { t, language } = useTranslation();
  
  // Re-compute sections when language changes
  const sections = useMemo(() => mapGdprToSections(t), [language]);
  const title = t('title', 'gdpr') || 'GDPR Compliance';
  const lastUpdated = t('lastUpdated', 'gdpr') || '';

  return <LegalLayout title={title} lastUpdated={lastUpdated} sections={sections} />;
};

export default GDPR;
